var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgBb = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M0 85.331h512v341.337H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 85.331h170.663v341.337H0zm341.337 0H512v341.337H341.337z",
  fill: "#0052b4"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M307.942 189.212l9.955 4.978-9.955-4.978-9.955-4.978c-.6 1.201-13.599 27.649-15.723 68.05H267.13v-63.073L256 174.372l-11.13 14.84v63.073h-15.133c-2.124-40.401-15.123-66.849-15.723-68.05l-19.911 9.955c.137.273 13.666 27.811 13.666 69.226v11.13h37.101v63.073h22.261v-63.073h37.101v-11.13c0-21.413 3.705-39.068 6.813-50.109 3.389-12.04 6.831-19.072 6.865-19.141l-9.968-4.954z"
})));

export default SvgBb;